import { post } from '../services/common/common.service';
import { emailEndPoints } from '../constants/endpoint';

export const sendEmailNotification = (payload) => post(emailEndPoints.sendEmail, payload);
export const sendEmailCopyNotification = (payload) => post(emailEndPoints.sendEmail, payload);
